export var AuthMethodMode;
(function (AuthMethodMode) {
    AuthMethodMode[AuthMethodMode["DEFAULT"] = 0] = "DEFAULT";
    AuthMethodMode[AuthMethodMode["SSO"] = 1] = "SSO";
})(AuthMethodMode || (AuthMethodMode = {}));
//# sourceMappingURL=auth-method.i.js.map